export const NO_ACTIVE_VALUE = Symbol('none');
export const INITIAL_LAST_HIGHLIGHT: { value: any; index: number } = {
  value: NO_ACTIVE_VALUE,
  index: -1,
} as const;
